import PropTypes from 'prop-types';
import React from 'react';
import clsx from 'clsx';
import { Info, X } from 'react-feather';
import './banner.scss';
import Icon, { IconSizes } from '../icon/icon';
import FeaturedIcon, { FeaturedIconColors, FeaturedIconSizes } from '../featured-icon';
import Button, { ButtonSizes } from '../button';
import { getRenderIcon } from '../../../utils/general-utils';

const BannerTypes = {
  GRAY: 'bn-gray',
  PRIMARY: 'bn-primary',
  SUCCESS: 'bn-success',
  WARNING: 'bn-warning',
  ERROR: 'bn-error',
};

const BannerSizes = {
  MEDIUM: 'bn-medium',
  LARGE: 'bn-large',
};

const IconColorMapping = {
  [BannerTypes.GRAY]: FeaturedIconColors.DARK,
  [BannerTypes.PRIMARY]: FeaturedIconColors.PRIMARY,
  [BannerTypes.SUCCESS]: FeaturedIconColors.SUCCESS,
  [BannerTypes.WARNING]: FeaturedIconColors.WARNING,
  [BannerTypes.ERROR]: FeaturedIconColors.ERROR,
};

const IconSizeMapping = {
  featuredIcon: {
    [BannerSizes.MEDIUM]: FeaturedIconSizes.MEDIUM,
    [BannerSizes.LARGE]: FeaturedIconSizes.LARGE,
  },
  closeButtonIcon: {
    [BannerSizes.MEDIUM]: IconSizes.SMALL,
    [BannerSizes.LARGE]: IconSizes.MEDIUM,
  },
};

const Banner = ({
  title, className, message, type, size, renderIcon, closeable, onClose, buttons, onButtonClick,
  hideIcon,
}) => {
  const getButtons = () => {
    const buttonViews = buttons.map(({
      id, label, type: buttonType, disabled, icon, borderLess, className: buttonClass,
    }) => (
      <Button
        label={label}
        type={buttonType}
        size={ButtonSizes.SMALL}
        onClick={() => onButtonClick(id)}
        key={id}
        disabled={disabled}
        renderIcon={getRenderIcon(icon)}
        borderLess={borderLess}
        className={buttonClass}
      />
    ));

    return (
      <div className="banner-buttons">
        {buttonViews}
      </div>
    );
  };

  return (
    <div className={clsx('banner-cont', type, size, className, { 'bn-with-close': closeable })}>
      {!hideIcon
        && (
        <FeaturedIcon
          renderIcon={renderIcon}
          size={IconSizeMapping.featuredIcon[size]}
          color={IconColorMapping[type]}
        />
        )}
      <div className="banner-content">
        {title && <div className="banner-title">{title}</div>}
        {message && <div className="banner-message">{message}</div>}
      </div>
      {buttons.length > 0 && getButtons()}
      <div className="banner-close">
        <Icon
          onClick={onClose}
          icon={X}
          size={IconSizeMapping.closeButtonIcon[size]}
        />
      </div>
    </div>
  );
};

Banner.defaultProps = {
  title: '',
  message: '',
  className: '',
  closeable: true,
  onClose: () => {},
  renderIcon: getRenderIcon(Info),
  type: BannerTypes.PRIMARY,
  size: BannerSizes.MEDIUM,
  buttons: [],
  onButtonClick: () => {},
  hideIcon: false,
};

Banner.propTypes = {
  title: PropTypes.string,
  message: PropTypes.string,
  className: PropTypes.string,
  closeable: PropTypes.bool,
  onClose: PropTypes.func,
  renderIcon: PropTypes.func,
  type: PropTypes.oneOf(Object.values(BannerTypes)),
  size: PropTypes.oneOf(Object.values(BannerSizes)),
  buttons: PropTypes.arrayOf(PropTypes.shape),
  onButtonClick: PropTypes.func,
  hideIcon: PropTypes.bool,
};

export {
  Banner as default,
  BannerTypes,
  BannerSizes,
};
